export default __webpack_public_path__ + "static/Nunito-Black-5fc265132e38160c8d2baacc2a1a0bf7.ttf";